// extracted by mini-css-extract-plugin
export default {"skeleton":"Skeleton-module--skeleton--df9c1","shine":"Skeleton-module--shine--c3f2e","square":"Skeleton-module--square--e0ee8"};